import type { ReactNode } from 'react';

/**
 * Visibly disables everything inside while a missing-data run is in progress.
 * A disabled <fieldset> disables every native input/button inside it (Mantine renders native ones);
 * pointer-events covers the rest, such as drag-to-reorder.
 */
export function LockedSection({ locked, children }: { locked: boolean; children: ReactNode }) {
  return (
    <fieldset
      disabled={locked}
      aria-busy={locked}
      style={{
        border: 0, margin: 0, padding: 0, minWidth: 0, height: '100%',
        opacity: locked ? 0.55 : 1,
        pointerEvents: locked ? 'none' : 'auto',
        transition: 'opacity 120ms',
      }}
    >
      {children}
    </fieldset>
  );
}
